import React from "react";
import SVGLoader from '../resources/Spin.svg';

import "./styles.scss";
function Loader(props) {
  return (
    <div className="loader-background" hidden={props.hidden}>
      <div className="loader">
        <object data={SVGLoader}></object>
      </div>
    </div>
  );
}
export default Loader;